import DoMoreWithRentalAccountActions from '../../../page-fragments/do-more-with-rental-account-actions/DoMoreWithRentalAccountActions';
import LocationAndDateSelector from '../../../components/location-and-date-selector/LocationAndDateSelector';
import renderer from '../../renderer';
import { useEffect } from 'react';
import {
  GenericRendererComponent,
  RendererComponentType,
  RendererSelectorType,
} from '../../../types/renderer';

const componentsRegister: GenericRendererComponent[] = [
  {
    componentType: RendererComponentType.GENERIC,
    selectorType: RendererSelectorType.ID,
    selector: 'esr-location-date-placeholder',
    component: () => {
      return <LocationAndDateSelector />;
    },
  },
  {
    componentType: RendererComponentType.GENERIC,
    selectorType: RendererSelectorType.ID,
    selector: 'esr-do-more-with-rental-account-actions',
    component: () => {
      return <DoMoreWithRentalAccountActions />;
    },
  },
];

function Home() {
  useEffect(() => {
    renderer(componentsRegister);
  }, []);

  return null;
}

export default Home;
